import React, { useState, useEffect, useRef } from "react";
import { Modal, Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import axios from "axios";
import { PRODUCT_IMAGE_ACCEPT, beforeUploadProductImg } from "./helper";
const CustomUploadMultiImage = ({ onChange, list, value }) => {
  // const productContext = useContext(LabelContext);
  const [state, setState] = useState({
    previewImage: "",
    previewTitle: "",
  });
  const [fileList, setFileList] = useState([]);

  /**
   * Олон зургийг зэрэг сонгоход `customRequest` нь зураг бүрд зэрэг ажиллана.
   * Тэдгээр нь render-ийн `fileList`-ыг барьдаг тул хожим дууссан хуулалт нь
   * эхлээд дууссаных нь хаягийг дарж устгана. Тиймээс хамгийн сүүлийн
   * жагсаалтыг ref-ээр барина.
   */
  const fileListRef = useRef([]);

  /** Жагсаалтыг төлөв, ref болон эцэг формд нэг дор шинэчилнэ */
  const updateList = (next) => {
    fileListRef.current = next;
    setFileList(next);
    onChange(next);
  };

  const [previewVisible, setPreviewVisible] = useState(false);

  useEffect(() => {
    const firstItem = value?.[0];
    if (
      firstItem &&
      typeof firstItem === "object" &&
      Object.keys(value).length > 0
    ) {
      setFileList(value);
      fileListRef.current = value;
    } else if (firstItem && typeof firstItem === "string") {
      let tmp = value?.map((url) => ({ url }));
      setFileList(tmp ?? []);
      fileListRef.current = tmp ?? [];
    }
  }, [value]);

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  const handleCancel = () => setPreviewVisible(false);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewVisible(true);
    setState({
      previewImage: file.url || file.preview,
      previewTitle:
        file.name || file.url.substring(file.url.lastIndexOf("/") + 1),
    });
  };

  const handleChange = ({ fileList: newFileList }) => updateList(newFileList);

  const { previewImage, previewTitle } = state;
  const uploadButton = (
    <div style={{ color: "rgba(0, 0, 0, 0.45)" }}>
      <PlusOutlined style={{ color: "black" }} />
      <div>Зураг оруулах</div>
    </div>
  );

  return (
    <>
      <Upload
        listType="picture-card"
        fileList={fileList}
        multiple
        accept={PRODUCT_IMAGE_ACCEPT}
        beforeUpload={beforeUploadProductImg}
        onPreview={handlePreview}
        onChange={handleChange}
        customRequest={async ({ file }) => {
          const formData = new FormData();
          formData.append("file", file);
          const res = await axios({
            method: "post",
            url: `${
              process.env.REACT_APP_STORAGE_URL
            }/upload/operator/product?fileName=product${Date.now()}&uid=${
              file.uid
            }`,
            data: formData,
          });
          const imagePath = res?.data?.result?.location ?? "";

          // Зэрэг хуулалтад хамгийн сүүлийн жагсаалтаас эхэлнэ — render-ийн
          // `fileList`-ыг барьвал бусад зургийн хаяг дарагдана
          const tmp = fileListRef.current.map((el) => {
            return el?.uid === file.uid
              ? {
                  ...el,
                  status: "done",
                  url: imagePath,
                }
              : el;
          });
          updateList(tmp);

          return imagePath;
        }}
      >
        {fileList.length >= 10 ? null : uploadButton}
      </Upload>
      <Modal
        visible={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img alt={previewTitle || "Зургийн урьдчилсан харагдац"} style={{ width: "100%" }} src={previewImage} />{" "}
      </Modal>
    </>
  );
};
export default CustomUploadMultiImage;
